var map = {
	"./black/fenzuhanhua.png": "jIkm",
	"./blue/fenzuhanhua.png": "fAt5",
	"./white/fenzuhanhua.png": "YbPF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xpoX";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/fenzuhanhua\.png$
// module id = xpoX
// module chunks = 24